/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Icons from "components/CustomIcons";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import ModalDevice3 from "layouts/apartment/Devices/DeviceModals/ModalDevice3";

function CardDevice3({ color, device, deviceState, sendValueServer, addresses }) {
  const [open, setOpen] = useState(false);
  const [rgb, setRgb] = useState("rgb(0,0,0)");
  const [intensity, setIntensity] = useState(undefined);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const is3Byte = device.type === "device4";
  const isOn = Boolean(addresses.find((a) => a.id === device.onOffStateAddress)?.value);

  const red = addresses.find((a) => a.id === device.redValueAddress)?.value;
  const green = addresses.find((a) => a.id === device.greenValueAddress)?.value;
  const blue = addresses.find((a) => a.id === device.blueValueAddress)?.value;
  const white = addresses.find((a) => a.id === device.whiteValueAddress)?.value;
  const valueState = addresses.find((a) => a.id === device.valueStateAddress)?.value;
  const intensityValue = addresses.find((a) => a.id === device.intensityValueAddress)?.value;

  useEffect(() => {
    if (white && white > 0) {
      setRgb("rgb(0,0,0)");
    } else if (is3Byte && typeof deviceState === "object" && deviceState !== null) {
      const { r = 0, g = 0, b = 0 } = deviceState;
      setRgb(`rgb(${r},${g},${b})`);
    } else {
      setRgb(
        `rgb(${Math.round((red ?? 0) * 2.55)},${Math.round((green ?? 0) * 2.55)},${Math.round(
          (blue ?? 0) * 2.55
        )})`
      );
    }

    if (intensityValue !== undefined) setIntensity(intensityValue);
  }, [is3Byte, red, green, blue, valueState, intensityValue, deviceState, white]);

  return (
    <Card sx={{ height: "100%", overflow: "hidden" }}>
      <Modal open={open} onClose={() => setOpen(false)}>
        <MDBox
          mt={3}
          sx={{
            width: "65vw",
            position: "absolute",
            left: "50%",
            transform: "translate(-50%, 0%)",
          }}
        >
          <ModalDevice3
            device={device}
            sendValueServer={sendValueServer}
            deviceState={is3Byte ? deviceState : isOn ? deviceState : 0}
            addresses={addresses}
          />
        </MDBox>
      </Modal>
      <MDBox
        p={2}
        height="100%"
        bgColor={isOn ? color : "white"}
        variant="gradient"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        onClick={() => setOpen(true)}
        sx={({ palette: { background } }) => ({
          background: darkMode && !isOn && background.card,
        })}
      >
        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Icons
            name={isOn ? "LightbulbOnOutline" : "LightbulbOutline"}
            size={40}
            color={darkMode ? "white" : "black"}
          />
          <MDBox
            mt={-0.5}
            mr={-1.5}
            onClick={(event) => {
              event.stopPropagation();
              sendValueServer(device.onOffAddress, {
                id: device.onOffAddress,
                value: isOn ? 0 : 1,
              });
            }}
          >
            <Switch checked={!!isOn} />
          </MDBox>
        </MDBox>

        <MDBox
          mt={1}
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <div
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
              backgroundColor: rgb,
              marginRight: 12,
            }}
          />
          <MDBox display="flex" flexDirection="column" flex="1">
            {intensity !== undefined && (
              <MDTypography color={isOn ? "white" : "text"}>{Math.round(intensity)}%</MDTypography>
            )}
          </MDBox>
        </MDBox>

        <MDTypography
          variant="body2"
          color={isOn ? "white" : "text"}
          marginTop="8px"
          textTransform="capitalize"
        >
          {device?.name?.toUpperCase()}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

CardDevice3.defaultProps = {
  color: "info",
  device: {},
  addresses: [],
  deviceState: {} || 0,
};

CardDevice3.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  device: PropTypes.object,
  sendValueServer: PropTypes.func.isRequired,
  addresses: PropTypes.array,
  deviceState: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
};

export default CardDevice3;
